import Box from "@mui/material/Box";
import PermissionsPageTitle from "permissions/_views/tables/permissions-page-title";

export default function PermissionsPageHeader() {
  return (
    <Box sx={{ px: 1, pt: 1 }}>
      <PermissionsPageTitle />
    </Box>
  );
}